import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './node.constants';
import * as types from './node.types';
import * as services from './node.saga-services';

function* invokeCreateNode(action: types.ICreateNode) {
  yield call(services.createNode, action.payload.node, action.payload.chartType);
}

function* invokeUpdateNode(action: types.IUpdateNode) {
  yield call(services.updateNode, action.payload.id, action.payload.data);
}

function* invokeUpdateNodesPositions(action: types.IUpdateNodesPositions) {
  yield call(services.updateNodesPositions, action.payload.chartType, action.payload.nodes);
}

function* invokeDeleteChartNode(action: types.IDeleteNode) {
  yield call(services.deleteNode, action.payload);
}

export function* watchNodePurePageSaga() {
  yield takeLatest(constants.CREATE_NODE, invokeCreateNode);
  yield takeLatest(constants.UPDATE_NODE, invokeUpdateNode);
  yield takeLatest(constants.UPDATE_NODES_POSITIONS, invokeUpdateNodesPositions);
  yield takeLatest(constants.DELETE_NODE, invokeDeleteChartNode);
}

export function* watchNodePageSaga() {
  yield all([watchNodePurePageSaga].map(fork));
}
